<script setup lang="ts">
import type { ReviewStatus } from '@/modules/Project/Fields/types'
import DarwinButton from '@/uiKit/DarwinButton.vue'
import IconSprite from '@/uiKit/IconSprite.vue'

defineProps<{
  reviewStatus: ReviewStatus
}>()

defineEmits<{
  'update-status': [ReviewStatus, Event]
}>()
</script>

<template>
  <template v-if="reviewStatus === 'pending'">
    <DarwinButton
      size="xs"
      variant="transparent"
      @click="$emit('update-status', 'rejected', $event)"
    >
      <template #leading-icon>
        <IconSprite icon="close" />
      </template>
      Reject
    </DarwinButton>
    <DarwinButton
      size="xs"
      variant="transparent"
      @click="$emit('update-status', 'approved', $event)"
    >
      <template #leading-icon>
        <IconSprite icon="check" />
      </template>
      Approve
    </DarwinButton>
  </template>
  <DarwinButton
    v-else
    size="xs"
    variant="transparent"
    @click="$emit('update-status', 'pending', $event)"
  >
    <template #leading-icon>
      <IconSprite icon="dismiss-human-task" />
    </template>
    Dismiss
  </DarwinButton>
</template>
